module.exports = __webpack_public_path__ + "static/divas5-9de18f8ec1cb9cefa8aa386ca47d8235.jpg";